export default {
  // Get editor state based on the module and id (optional).
  getEditorState: state => (module, id = null) => {
    const modules = ['blog', 'news', 'page', 'press', 'reference', 'structure', 'branch'];

    // Check if the data object contains module name and if it is correct
    if (!modules.includes(module)) {
      return null;
    }

    const savedState = state.module[module];
    const isEmpty = Object.keys(savedState).length === 0;

    // Check if the module is valid
    if (savedState && !isEmpty && modules.includes(module)) {
      // Check that the id
      if ((savedState.data.id && Number(savedState.data.id) === Number(id)) || (!savedState.data.id && id === null)) {
        // Retrieve the savedState for the module
        return savedState;
      }
    }

    // If the module or id is not valid, return null
    return null;
  },
};
